import React from "react";
import ClassNames from "classnames";
import TextFieldMUI from "@material-ui/core/TextField";
import makeStyles from "@material-ui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-input": {
        padding: "14.5px 15px",
      },
    },
    "& .MuiInputLabel-outlined": {
      transform: "translate(14px, 16px) scale(1)",
      "&.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)",
      },
    },
  },
}));

function TextField(props) {
  const classes = useStyles(props);

  return <TextFieldMUI className={ClassNames(classes.root)} {...props} />;
}

export default TextField;
